import React from 'react';

const SizeUnderwear = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.7427 17.2022C11.6743 16.0843 13.0913 16.0843 13.8365 17.2022"
            stroke="#323232"
            strokeWidth="1.5"
        />
        <path
            d="M19.1476 4L19.7066 10.7075L20.6382 4H19.1476Z"
            stroke="#323232"
            strokeWidth="1.5"
            strokeLinejoin="round"
        />
        <path
            d="M5.44026 4L4.8813 10.7075L3.94971 4H5.44026Z"
            stroke="#323232"
            strokeWidth="1.5"
            strokeLinejoin="round"
        />
        <path
            d="M4.89595 10.8004L12.157 14.9926C11.9964 15.2707 11.5824 16.036 11.4119 16.2835C10.2008 18.3812 7.92334 19.2175 5.88064 18.0382C3.83795 16.8588 2.5833 14.806 4.16701 12.063C4.29497 11.7985 4.73179 11.0847 4.89595 10.8004Z"
            stroke="#323232"
            strokeWidth="1.5"
            strokeLinejoin="round"
        />
        <path
            d="M19.6895 10.8004L12.4284 14.9926C12.589 15.2707 13.003 16.036 13.1736 16.2835C14.3846 18.3812 16.6621 19.2175 18.7048 18.0382C20.7475 16.8588 22.0022 14.806 20.4184 12.063C20.2905 11.7985 19.8537 11.0847 19.6895 10.8004Z"
            stroke="#323232"
            strokeWidth="1.5"
            strokeLinejoin="round"
        />
    </svg>
);

export default SizeUnderwear;
